<div class="footer-main content-web-section" id="pop-up-content" role="contentinfo">
    <div class="inner-footer-container">
        <div class="popup-section">
            <!-- <div class="pop-up-icon text-center cursor-pointer">
                <span (click)="setPopUp(true)" *ngIf="!showPopUp">
                    <span class="pop-up-icon-text">Let us help you</span> &nbsp;
                    <img class="icn-img" src="assets/icons/up_white_arrow.png">
                </span>
                <span (click)="setPopUp(false)" *ngIf="showPopUp">
                    <span class="pop-up-icon-text">Let us help you</span> &nbsp;
                    <img class="icn-img" src="assets/icons/down_white_arrow.png">
                </span> -->
            <button type="button" class="pop-up-icon" [attr.aria-expanded]="showPopUp" aria-controls="help-panel"
                (click)="setPopUp(!showPopUp)">

                <h2 class="pop-up-icon-text">
                    Let us help you
                </h2>

                <img class="icn-img" [src]="showPopUp
                            ? 'assets/icons/down_white_arrow.png'
                            : 'assets/icons/up_white_arrow.png'" alt="" aria-hidden="true">
            </button>

            <div id="help-panel" class="pop-up-content" *ngIf="showPopUp">



            </div>
            <div class="pop-up-content " *ngIf="showPopUp">
                <!-- <form name="form" (ngSubmit)="f.form.valid && submitContactDetails(f)" #f="ngForm" novalidate> -->
                <form name="form" #f="ngForm" novalidate (ngSubmit)="onSubmit(f)">
                    <div class="pop-up-data ">
                        <span class="pop-up-heading">Please provide your contact details to assist you better in your
                            investment journey</span>

                        <div class="col-lg-12 pt-2 row">
                            <div class="col-lg-6 full-name">
                                <label for="fullName" class="lbl-text">Full Name</label><br>
                                <input type="text" id="fullName" [pattern]="alphaPattern" minlength="1" maxlength="32"
                                    [(ngModel)]="userData.name" name="fname" #fname="ngModel" autocomplete="name"
                                    required [attr.aria-invalid]="f.submitted && fname.invalid"
                                    aria-describedby="fullNameError">
                                <div *ngIf="f.submitted && fname.invalid" id="fullNameError" class="error-text-footer"
                                    role="alert">
                                    <div *ngIf="fname.errors?.['required']">Full Name is required</div>
                                    <div *ngIf="fname.errors?.['pattern']">Name not valid.</div>
                                </div>
                            </div>
                            <div class="col-lg-6 mobile-number">
                                <label for="mobile" class="lbl-text">Mobile</label><br>
                                <input type="text" class="mobText" minlength="14" (keypress)="numberOnly($event)"
                                    maxlength="14" [pattern]="mobNumberPattern" id="mobile"
                                    [(ngModel)]="userData.phoneNum" autocomplete="tel" name="mobile" #mobile="ngModel"
                                    required [attr.aria-invalid]="f.submitted && mobile.invalid"
                                    aria-describedby="mobileError">
                                <div *ngIf="f.submitted && mobile.invalid" id="mobileError" class="error-text-footer"
                                    role="alert">
                                    <div *ngIf="mobile.errors?.['required']">Mobile number required</div>
                                    <div *ngIf="mobile.errors?.['pattern']">Mobile number not valid.</div>
                                </div>
                            </div>
                        </div>

                        <span class="help-footer-text">By entering your details, you hereby authorize ITI Mutual
                            Fundand/or its authorized service
                            provider(s) to contact you and this will override any NDNC registration made by
                            you.</span><br><br>
                        <button type="submit" class="submit-button">Submit</button>
                        <br><br>
                    </div>
                </form>

            </div>
        </div>
        <div class="footer-content ">
            <!-- <img src="assets/icons/bac_ to_top.png" class="cursor-pointer  pull-right" (click)="gotoTop()"> -->
            <button type="button" class="to-top-btn to-top pull-right" (click)="gotoTop()" aria-label="Back to top">

                <img src="assets/icons/up_white_arrow.png" alt="">
            </button>
            <div class="col-12 row footer-content-col">
                <div class="col-2  space-section"></div>
                <div class="col-8  link-section">
                    <div class="col-12 row footer-link-section">
                        <div class="col-3">
                            <h2 class="footer-section-heading"> Key Policies</h2>
                            <uL class="footer-links">
                                <!-- <li class="cursor-pointer" *ngFor="let item of footerLinks?.keyPolicies"
                                    (click)="navFooterLink(item.url)">{{item.displayName}}</li> -->
                                <!-- <li -->
                                <li *ngFor="let item of footerLinks?.keyPolicies">
                                    <a [routerLink]="item.url">
                                        {{item.displayName}}
                                    </a>
                                </li>
                            </uL>

                        </div>
                        <div class="col-3 custom-width-1">
                            <h2 class="footer-section-heading"> Quick links</h2>
                            <uL class="footer-links">
                                <!-- <li class="cursor-pointer" (click)="accountStatements()">Account Statements</li> -->
                                <li>
                                    <a href="https://mfs.kfintech.com/investor/General/StatementsAndReports"
                                        target="_blank" rel="noopener noreferrer">
                                        Account Statements
                                    </a>
                                </li>
                                <!-- <li class="cursor-pointer" *ngFor="let item of footerLinks?.quickLinks"
                                    (click)="navFooterLink(item.url)">{{item.displayName}}</li> -->
                                <li *ngFor="let item of footerLinks?.quickLinks">
                                    <a [routerLink]="item.url">
                                        {{item.displayName}}
                                    </a>
                                </li>
                                <!-- <li class="cursor-pointer" (click)="digitalKyc()">Digital KYC</li> -->
                                <li>
                                    <a href="https://investonline.itiamc.com/login/kyc" target="_blank"
                                        rel="noopener noreferrer">
                                        Digital KYC
                                    </a>
                                </li>
                                <!-- <li class="cursor-pointer"(click)="ARNHardcodedLink()">ARN Hardcoded Link</li> -->
                                <li>
                                    <a href="https://welcome.itiamc.com/Promotions" target="_blank"
                                        rel="noopener noreferrer">
                                        ARN Hardcoded Link
                                    </a>
                                </li>
                                <!-- <li class="cursor-pointer"(click)="externalLink('MITRA')">MITRA Platform</li> -->
                                <li>
                                    <a href="https://app.mfcentral.com/links/inactive-folios" target="_blank"
                                        rel="noopener noreferrer">
                                        MITRA Platform
                                    </a>
                                </li>
                                <!-- <li class="cursor-pointer"(click)="externalLink('KYC')">Update KYC</li> -->
                                <li>
                                    <a href="https://mfs.kfintech.com/Investor/General/ValidateKYC" target="_blank"
                                        rel="noopener noreferrer">
                                        Update KYC
                                    </a>
                                </li>
                                <li>
                                    <a href="https://mfs.kfintech.com/investor/General/distributerCorner?AMCCODE=CCAB2FC7-F0C5-4E58-ACC6-860704A9902F"
                                        target="_blank" rel="noopener noreferrer">
                                        Distributor Empanelment Disclosure
                                    </a>
                                </li>
                                <li>
                                    <a href="https://eservices.nsdl.com/cas-stmt-mf-conv/?src=nsdlcorp" target="_blank"
                                        rel="noopener noreferrer">
                                        Electronic Dematerialization for NSDL
                                    </a>
                                </li>
                            </uL>

                        </div>
                        <div class="col-3 custom-width-2">
                            <h2 class="footer-section-heading"> External Links</h2>
                            <uL class="footer-links">
                                <!-- <li class="cursor-pointer" *ngFor="let item of footerLinks?.otherLinks"
                                    (click)="viewWebsite(item.url)">{{item.displayName}}</li> -->
                                <li *ngFor="let item of footerLinks?.otherLinks">
                                    <a [href]="item.url" target="_blank" rel="noopener noreferrer">
                                        {{item.displayName}}
                                    </a>
                                </li>
                            </uL>

                        </div>
                        <div class="col-3">
                            <h2 class="footer-section-heading"> Help</h2>
                            <uL class="footer-links">
                                <!-- <li class="cursor-pointer" *ngFor="let item of footerLinks?.HelpLinks"
                                    (click)="openHelpers(item.url)">{{item.displayName}}</li> -->
                                <li *ngFor="let item of footerLinks?.HelpLinks">

                                    <a *ngIf="item.url !== 'call-back'
                                            && item.url !== 'write-to-us'
                                            && item.url !== 'locate-us'" [routerLink]="item.url">
                                        {{item.displayName}}
                                    </a>

                                    <button *ngIf="item.url === 'call-back'
                                        || item.url === 'write-to-us'
                                        || item.url === 'locate-us'" type="button" (click)="openHelpers(item.url)">
                                        {{item.displayName}}
                                    </button>

                                </li>
                            </uL>

                        </div>

                    </div>
                    <div class="col-12 copy-right">
                        © {{date| date:'yyyy'}} ITI Mutual Fund. All rights reserved
                        <p class="browser-compatibility-text">
                            Site best viewed in Chrome v85 +, Firefox v82 +, Safari v14 +, Microsoft Edge v85 +
                            browsers.
                        </p>
                        <hr class="footer-hr">
                    </div>
                    <br> <br> <br>
                    <div class="col-12 row">
                        <!-- <div class="contact-infos col-6">
                            <i class="fa fa-envelope footer-icon" role="img" aria-label="Email"></i> &nbsp;&nbsp; <a
                                class="footer-icon-text footer-icon-text-border" href="mailto:mfassist@itiorg.com">
                                mfassist&#64;itiorg.com</a>
                            <i class="fa fa-phone footer-icon footer-icon2" role="img" aria-label="Phone"></i>&nbsp;&nbsp;<a
                                class="footer-icon-text" href="tel:1800-266-9603"> 1800-266-9603</a>

                        </div> -->
                        <div class="contact-infos col-6">

                            <ul class="contact-list">

                                <li>
                                    <i class="fa fa-envelope footer-icon" aria-hidden="true"></i>

                                    <a class="footer-icon-text" href="mailto:mfassist@itiorg.com">

                                        mfassist&#64;itiorg.com

                                    </a>
                                </li>

                                <li>

                                    <i class="fa fa-phone footer-icon footer-icon2" aria-hidden="true"></i>

                                    <a class="footer-icon-text" href="tel:18002669603">

                                        1800-266-9603

                                    </a>

                                </li>

                            </ul>

                        </div>
                        <div class="social-media-iconss col-6 align-h">
                            <h3 class="footer-social-share-text">Follow Us On: </h3>
                            <!-- <div>
                                <img src="assets/icons/icon_fb.png" class="cursor-pointer "
                                    (click)="viewWebsite('https://m.facebook.com/ITIMutualFund/')"> &nbsp;
                                <img src="assets/ITI-IAP-HTML/images/X.png" class="cursor-pointer"
                                    (click)="viewWebsite('https://twitter.com/itimutualfund?lang=en')">&nbsp;
                                <img src="assets/icons/icon_youtube.png" class="cursor-pointer"
                                    (click)="viewWebsite('https://www.youtube.com/channel/UCpWl987-ƒi9dvbfiTOLQIƒleQ')">&nbsp;
                                <img src="assets/icons/icon_insta.png" class="cursor-pointer"
                                    (click)="viewWebsite('https://www.instagram.com/iti.mutualfund/?igshid=uaoiy8hqltnq')">&nbsp;
                                <img src="assets/ITI-IAP-HTML/images/Indeed.png" class="cursor-pointer footer-social-media" (click)="viewWebsite('https://www.linkedin.com/company/iti-mutual-fund/')">&nbsp;
                            </div> -->
                            <ul class="footer-social-list">

                                <li>


                                    <a href="https://m.facebook.com/ITIMutualFund/" target="_blank"
                                        rel="noopener noreferrer" aria-label="Visit our Facebook page">

                                        <img src="assets/icons/icon_fb.png" class="footer-social-media" alt="">
                                    </a>&nbsp;
                                </li>

                                <li>

                                    <a href="https://twitter.com/itimutualfund?lang=en" target="_blank"
                                        rel="noopener noreferrer" aria-label="Visit our X profile">

                                        <img src="assets/ITI-IAP-HTML/images/X.png" class="footer-social-media" alt="">
                                    </a>&nbsp;
                                </li>

                                <li>

                                    <a href="https://www.youtube.com/channel/UCpWl987-i9dvbfiTOLQIleQ" target="_blank"
                                        rel="noopener noreferrer" aria-label="Visit our YouTube channel">

                                        <img src="assets/icons/icon_youtube.png" class="footer-social-media" alt="">
                                    </a>&nbsp;
                                </li>

                                <li>

                                    <a href="https://www.instagram.com/iti.mutualfund/?igshid=uaoiy8hqltnq"
                                        target="_blank" rel="noopener noreferrer"
                                        aria-label="Visit our Instagram profile">

                                        <img src="assets/icons/icon_insta.png" class="footer-social-media" alt="">
                                    </a>&nbsp;
                                </li>

                                <li>

                                    <a href="https://www.linkedin.com/company/iti-mutual-fund/" target="_blank"
                                        rel="noopener noreferrer" aria-label="Visit our Indeed page">

                                        <img src="assets/ITI-IAP-HTML/images/Indeed.png" class="footer-social-media"
                                            alt="">
                                    </a>&nbsp;
                                </li>

                            </ul>
                        </div>
                    </div>
                    <div class="col-12 row">
                        <div class="contact-infos col-8">
                            <p class="footer-icon-text footer-icon-text-border fs-16">SEBI Regn Name: ITI Mutual Fund |
                                Regn No: MF/073/18/01</p>
                        </div>
                        <div class="contact-infos col-8">
                            <p class="footer-icon-text footer-icon-text-border fs-16">ITI Asset Management Limited</p>
                        </div>
                        <div class="contact-infos col-8">
                            <p class="footer-icon-text footer-icon-text-border fs-16">CIN. : U67100MH2008PLC177677</p>
                        </div>

                    </div>

                </div>
                <div class="col-2   space-section"></div>

            </div>
        </div>

        <p class="text-center market-risks" [ngStyle]="{'padding-bottom': flag ? '50px' : '0px'}"> Mutual Fund
            investments are subject to market risks, read all scheme related documents carefully. </p>
    </div>
</div>




<div class="footer-main footer-main-mobile content-mobile-section" id="pop-up-content" role="contentinfo">
    <div class="popup-section">
        <!-- <div class="pop-up-icon text-center cursor-pointer">
            <span (click)="setPopUp(true)" *ngIf="!showPopUp">
                <span class="pop-up-icon-text">Let us help you </span>
                <img class="icn-img" src="assets/icons/up_white_arrow.png">
            </span>
            <span (click)="setPopUp(false)" *ngIf="showPopUp">
                <span class="pop-up-icon-text">Let us help you </span>
                <img class="icn-img" src="assets/icons/down_white_arrow.png">
            </span>

        </div> -->
        <button type="button" class="pop-up-icon" [attr.aria-expanded]="showPopUp" aria-controls="help-panel-mobile"
            (click)="setPopUp(!showPopUp)">

            <span class="pop-up-icon-text">
                Let us help you
            </span>

            <img class="icn-img" [src]="showPopUp
                    ? 'assets/icons/down_white_arrow.png'
                    : 'assets/icons/up_white_arrow.png'" alt="" aria-hidden="true">
        </button>
        <!-- <div class="pop-up-content " *ngIf="showPopUp"> -->
        <div id="help-panel-mobile" class="pop-up-content" *ngIf="showPopUp">
            <form name="form" (ngSubmit)="f.form.valid && submitContactDetails(f)" #f="ngForm" novalidate>
                <div class="pop-up-data ">
                    <br><br> <span class="pop-up-heading">Please provide your contact details to assist you better in
                        your investment journey</span><br><br>

                    <div class="col-lg-12 row">
                        <div class="col-lg-6">
                            <label for="fullName" class="lbl-text">Full Name</label><br>
                            <input type="text" id="fullName" [pattern]="alphaPattern" minlength="1" maxlength="32"
                                [(ngModel)]="userData.name" name="fname" #fname="ngModel" autocomplete="name" required>
                            <div *ngIf="f.submitted && fname.invalid" class="error-text-footer">
                                <div *ngIf="fname.errors?.['required']">Full Name is required</div>
                                <div *ngIf="fname.errors?.['pattern']">Name not valid.</div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <label for="mobile" class="lbl-text">Mobile</label><br>
                            <input type="text" class="mobText" minlength="14" (keypress)="numberOnly($event)"
                                maxlength="14" [pattern]="mobNumberPattern" id="mobile" [(ngModel)]="userData.phoneNum"
                                autocomplete="tel" name="mobile" #mobile="ngModel" required>
                            <div *ngIf="f.submitted && mobile.invalid" class="error-text-footer">
                                <div *ngIf="mobile.errors?.['required']">Mobile number required</div>
                                <div *ngIf="mobile.errors?.['pattern']">Mobile number not valid.</div>
                            </div>
                        </div>
                    </div>

                    <br><br>
                    <span class="help-footer-text">By entering your details, you hereby authorize ITI Mutual Fundand/or
                        its authorized service
                        provider(s) to contact you and this will override any NDNC registration made by
                        you.</span><br><br>
                    <button type="submit" class="submit-button">Submit</button>
                    <br><br>
                </div>
            </form>

        </div>
    </div>
    <div class="footer-content ">
        <div class="col-lg-12 row footer-content-col">
            <div class="col-lg-2 space-section"></div>
            <div class="col-lg-8 link-section">
                <div class="col-lg-12 row footer-link-section">
                    <div class="col-lg-3 footer-link-line">
                        <span class="footer-section-heading" (click)="setActive(1)"> Key Policies
                            <span class="footer-arrow">
                                <img src="assets/icons/down_white_arrow.png" class="img-arrow" *ngIf="activeId!==1">
                                <img src="assets/icons/up_white_arrow.png" class="img-arrow" *ngIf="activeId===1">
                            </span>
                        </span>
                        <uL class="footer-links" *ngIf="activeId===1">
                            <!-- <li class="cursor-pointer" *ngFor="let item of footerLinks?.keyPolicies"
                                (click)="navFooterLink(item.url)">{{item.displayName}}</li> -->
                            <li *ngFor="let item of footerLinks?.keyPolicies">
                                <a [routerLink]="item.url">
                                    {{item.displayName}}
                                </a>
                            </li>
                        </uL>

                    </div>
                    <div class="col-lg-3 footer-link-line">
                        <span class="footer-section-heading" (click)="setActive(2)"> Quick links
                            <span class="footer-arrow">
                                <img src="assets/icons/down_white_arrow.png" class="img-arrow" *ngIf="activeId!==2">
                                <img src="assets/icons/up_white_arrow.png" class="img-arrow" *ngIf="activeId===2">
                            </span>
                        </span>
                        <uL class="footer-links" *ngIf="activeId===2">
                            <!-- <li class="cursor-pointer" (click)="accountStatements()">Account Statements</li> -->
                            <li>
                                <a href="https://mfs.kfintech.com/investor/General/StatementsAndReports" target="_blank"
                                    rel="noopener noreferrer">
                                    Account Statements
                                </a>
                            </li>
                            <!-- <li class="cursor-pointer" *ngFor="let item of footerLinks?.quickLinks"
                                (click)="navFooterLink(item.url)">{{item.displayName}}</li> -->
                            <li *ngFor="let item of footerLinks?.quickLinks">
                                <a [routerLink]="item.url">
                                    {{item.displayName}}
                                </a>
                            </li>
                            <!-- <li class="cursor-pointer" (click)="digitalKyc()">Digital KYC</li> -->
                            <li>
                                <a href="https://investonline.itiamc.com/login/kyc" target="_blank"
                                    rel="noopener noreferrer">
                                    Digital KYC
                                </a>
                            </li>
                            <!-- <li class="cursor-pointer" (click)="externalLink('KYC')">Update KYC</li> -->
                            <li>
                                <a href="https://mfs.kfintech.com/Investor/General/ValidateKYC" target="_blank"
                                    rel="noopener noreferrer">
                                    Update KYC
                                </a>
                            </li>
                            <li>
                                <a href="https://mfs.kfintech.com/investor/General/distributerCorner?AMCCODE=CCAB2FC7-F0C5-4E58-ACC6-860704A9902F"
                                    target="_blank" rel="noopener noreferrer">
                                    Distributor Empanelment Disclosure
                                </a>
                            </li>
                            <li>
                                <a href="https://eservices.nsdl.com/cas-stmt-mf-conv/?src=nsdlcorp" target="_blank"
                                    rel="noopener noreferrer">
                                    Electronic Dematerialization for NSDL
                                </a>
                            </li>
                        </uL>

                    </div>
                    <div class="col-lg-3 footer-link-line">
                        <span class="footer-section-heading" (click)="setActive(3)"> External Links
                            <span class="footer-arrow">
                                <img src="assets/icons/down_white_arrow.png" class="img-arrow" *ngIf="activeId!==3">
                                <img src="assets/icons/up_white_arrow.png" class="img-arrow" *ngIf="activeId===3">
                            </span>
                        </span>
                        <uL class="footer-links" *ngIf="activeId===3">
                            <!-- <li class="cursor-pointer" *ngFor="let item of footerLinks?.otherLinks"
                                (click)="viewWebsite(item.url)">{{item.displayName}}</li> -->
                            <li *ngFor="let item of footerLinks?.otherLinks">
                                <a [href]="item.url" target="_blank" rel="noopener noreferrer">
                                    {{item.displayName}}
                                </a>
                            </li>
                        </uL>

                    </div>
                    <div class="col-lg-3 footer-link-line">
                        <span class="footer-section-heading" (click)="setActive(4)"> Help
                            <span class="footer-arrow">
                                <img src="assets/icons/down_white_arrow.png" class="img-arrow" *ngIf="activeId!==4">
                                <img src="assets/icons/up_white_arrow.png" class="img-arrow" *ngIf="activeId===4">
                            </span>
                        </span>
                        <uL class="footer-links" *ngIf="activeId===4">
                            <!-- <li class="cursor-pointer" *ngFor="let item of footerLinks?.HelpLinks"
                                (click)="openHelpers(item.url)">{{item.displayName}}</li> -->
                            <li *ngFor="let item of footerLinks?.HelpLinks">

                                <a *ngIf="item.url !== 'call-back'
                                        && item.url !== 'write-to-us'
                                        && item.url !== 'locate-us'" [routerLink]="item.url">
                                    {{item.displayName}}
                                </a>

                                <button *ngIf="item.url === 'call-back'
                                    || item.url === 'write-to-us'
                                    || item.url === 'locate-us'" type="button" (click)="openHelpers(item.url)">
                                    {{item.displayName}}
                                </button>

                            </li>
                        </uL>

                    </div>

                </div>

                <br>
                <div class="col-lg-12 row">
                    <!-- <div class="contact-infos col-lg-12">
                        <i class="fa fa-envelope footer-icon" aria-hidden="true"></i> &nbsp;&nbsp; <a
                            class="footer-icon-text footer-icon-text-border" href="mailto:mfassist@itiorg.com">
                            mfassist&#64;itiorg.com</a>
                        <i class="fa fa-phone footer-icon footer-icon2" aria-hidden="true"></i>&nbsp;&nbsp;<a
                            class="footer-icon-text" href="tel:1800-266-9603"> 1800-266-9603</a>

                    </div> -->

                    <div class="contact-infos col-lg-12">

                        <ul class="contact-list">

                            <li>
                                <i class="fa fa-envelope footer-icon" aria-hidden="true"></i>

                                <a class="footer-icon-text" href="mailto:mfassist@itiorg.com">

                                    mfassist&#64;itiorg.com

                                </a>
                            </li>

                            <li>

                                <i class="fa fa-phone footer-icon footer-icon2" aria-hidden="true"></i>

                                <a class="footer-icon-text" href="tel:18002669603">

                                    1800-266-9603

                                </a>

                            </li>

                        </ul>

                    </div>

                    <div class="contact-infos col-lg-12">
                        <p class="footer-icon-text footer-icon-text-border fs-16">SEBI Regn Name: ITI Mutual Fund | Regn
                            No: MF/073/18/01</p>
                    </div>
                    <div class="contact-infos col-lg-12">
                        <p class="footer-icon-text footer-icon-text-border fs-16">ITI Asset Management Limited</p>
                    </div>
                    <div class="contact-infos col-lg-12">
                        <p class="footer-icon-text footer-icon-text-border fs-16">CIN. : U67100MH2008PLC177677</p>
                    </div>


                    <div class="social-media-iconss col-lg-12 text-center">
                        <div class="footer-social-share-text margin-bottom-15">Follow Us On: </div>
                        <ul class="footer-social-list">
                            <!-- <img src="assets/icons/icon_fb.png" class="cursor-pointer footer-social-media"
                                (click)="viewWebsite('https://m.facebook.com/ITIMutualFund/')"> &nbsp; -->
                            <li>
                                <a href="https://m.facebook.com/ITIMutualFund/" target="_blank"
                                    rel="noopener noreferrer" aria-label="Visit our Facebook page">

                                    <img src="assets/icons/icon_fb.png" class="footer-social-media" alt="">


                                </a>
                            </li>
                            <!-- <img src="assets/ITI-IAP-HTML/images/X.png" class="cursor-pointer footer-social-media"
                                (click)="viewWebsite('https://twitter.com/itimutualfund?lang=en')">&nbsp; -->
                            <li>
                                <a href="https://twitter.com/itimutualfund?lang=en" target="_blank"
                                    rel="noopener noreferrer" aria-label="Visit our X profile">

                                    <img src="assets/ITI-IAP-HTML/images/X.png" class="footer-social-media" alt="">
                                </a>
                            </li>
                            <!-- <img src="assets/icons/icon_youtube.png" class="cursor-pointer footer-social-media"
                                (click)="viewWebsite('https://www.youtube.com/channel/UCpWl987-i9dvbfiTOLQIleQ')">&nbsp; -->
                            <li>
                                <a href="https://www.youtube.com/channel/UCpWl987-i9dvbfiTOLQIleQ" target="_blank"
                                    rel="noopener noreferrer" aria-label="Visit our YouTube channel">

                                    <img src="assets/icons/icon_youtube.png" class="footer-social-media" alt="">
                                </a>
                            </li>
                            <!-- <img src="assets/icons/icon_insta.png" class="cursor-pointer footer-social-media"
                                (click)="viewWebsite('https://www.instagram.com/iti.mutualfund/?igshid=uaoiy8hqltnq')">&nbsp; -->
                            <li>
                                <a href="https://www.instagram.com/iti.mutualfund/?igshid=uaoiy8hqltnq" target="_blank"
                                    rel="noopener noreferrer" aria-label="Visit our Instagram profile">

                                    <img src="assets/icons/icon_insta.png" class="footer-social-media" alt="">
                                </a>
                            </li>
                            <!-- <img src="assets/ITI-IAP-HTML/images/Indeed.png" class="cursor-pointer footer-social-media" (click)="viewWebsite('https://www.linkedin.com/company/iti-mutual-fund/')">&nbsp; -->
                            <li>
                                <a href="https://www.linkedin.com/company/iti-mutual-fund/" target="_blank"
                                    rel="noopener noreferrer" aria-label="Visit our Indeed page">

                                    <img src="assets/ITI-IAP-HTML/images/Indeed.png" class="footer-social-media" alt="">
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div class="align-h margin-left-25">
                        <div class="stretch copy-right text-center">
                            © {{date| date:'yyyy'}} ITI Mutual Fund. All rights reserved

                        </div>
                        <!-- <div class="">
                            <img class="cursor-pointer" src="assets/icons/bac_ to_top.png" (click)="gotoTop()" />
                        </div> -->
                        <div>
                            <button type="button" class="to-top-btn" (click)="gotoTop()" aria-label="Back to top">

                                <img src="assets/icons/up_white_arrow.png" alt="">
                            </button>
                        </div>
                    </div>
                    <br><br>
                </div>

            </div>
            <div class="col-lg-2 space-section"></div>

        </div>
    </div>

    <p class="text-center market-risks" [ngStyle]="{'padding-bottom': flag ? '40px' : '0px'}"> Mutual Fund investments
        are subject to market risks, read all scheme related documents carefully. </p>
</div>